import React from 'react'
import { format, formatDistance, isValid, parseJSON } from 'date-fns'
import PropTypes from 'prop-types'

function formatCreatedAtField(dateString) {
  const date = parseJSON(dateString)
  if (!isValid(date)) {
    return '---'
  }
  const formattedDate = format(date, 'dd-MM-yyyy HH:mm')
  return `${formattedDate} (${formatDistance(date, new Date())} ago)`
}

/**
 * Fetch from backend and store into state.
 * @param {Object} props
 * @param {import('../../../../apis/order.type').OrderModel} props.order
 */
function SelectedOrderHeader(props) {
  const { order } = props

  return (
    <table>
      <tbody>
        <tr>
          <td style={{ paddingRight: '3rem' }}>
            <strong>Selected Order:</strong>
          </td>
          <td>{order.orderNo}</td>
        </tr>
        <tr>
          <td style={{ paddingRight: '3rem' }}>
            <strong>Customer:</strong>
          </td>
          <td>{order.orgName}</td>
        </tr>
        <tr>
          <td style={{ paddingRight: '3rem' }}>
            <strong>Created At:</strong>
          </td>
          <td>{formatCreatedAtField(order.createdAt)}</td>
        </tr>
      </tbody>
    </table>
  )
}

SelectedOrderHeader.propTypes = {
  order: PropTypes.object
}

export default SelectedOrderHeader
